import { t } from "@/i18n-js/instance";
import { Header, useCustomizeUIData } from "@circle-react-shared/CustomizeUI";
import { FullScreenModal } from "@circle-react-shared/ModalsV2/FullScreenModal";
import { SelectRadioGroup } from "@circle-react-uikit/SelectRadioGroup";
import { Tabs } from "@circle-react-uikit/Tabs";
import { Typography } from "@circle-react-uikit/Typography";

export const HomeCustomizeUIHeader = () => {
  const {
    sections,
    currentSection,
    setCurrentSection,
    formId,
    title,
    isSaving,
    onExit,
  } = useCustomizeUIData();

  const radioOptions = sections.map(value => ({
    value,
    label: value,
  }));

  return (
    <>
      <FullScreenModal.Header>
        <div className="flex items-center">
          <div className="invisible w-9"></div>
          {title && (
            <span className="fixed left-[20px] truncate md:max-w-[20%]">
              <Typography.LabelMd weight="semibold">{title}</Typography.LabelMd>
            </span>
          )}
        </div>
        <Header.Actions className="items-center justify-center">
          <div className="hidden md:block">
            <SelectRadioGroup
              value={currentSection}
              onChange={setCurrentSection}
              options={radioOptions}
            />
          </div>
        </Header.Actions>
        <Header.Actions>
          <Header.SaveButton
            onClick={onExit}
            formId={formId}
            disabled={isSaving}
            variant="circle"
          >
            {t("customize_space.done")}
          </Header.SaveButton>
        </Header.Actions>
      </FullScreenModal.Header>
      <div className="border-primary sticky w-full border-b px-6 md:hidden">
        <Tabs
          controlled
          onChange={setCurrentSection}
          activeTab={currentSection}
          options={radioOptions}
        />
      </div>
    </>
  );
};
